import React from "react";
import { Modal, Row, Col, Typography } from "antd";
import { Column } from "@ant-design/plots";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const SatisfactionDetailModal = ({
  isSatisfactionModalVisible,
  modalTitle,
  handleModalCancel,
  mostUnsatisfiedConsultantsConfig,
  mostSatisfiedConsultantsConfig,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        title={`${modalTitle} ${t("home.satisfactionModal.satisfaction")}`}
        open={isSatisfactionModalVisible}
        onCancel={handleModalCancel}
        okButtonProps={{ style: { display: "none" } }}
        width={1000}
        cancelText={t("home.satisfactionModal.back")}
      >
        <Row style={{ marginBottom: "2rem" }}>
          <Text type="secondary">
            {t("home.satisfactionModal.topUnsatisfied")}
          </Text>
        </Row>

        <Row>
          <Col span={24}>
            <Column {...mostUnsatisfiedConsultantsConfig} />
          </Col>
        </Row>

        <Row style={{ marginTop: "2rem", marginBottom: "2rem" }}>
          <Text type="secondary">
            {t("home.satisfactionModal.topSatisfied")}
          </Text>
        </Row>

        <Row>
          <Col span={24}>
            <Column {...mostSatisfiedConsultantsConfig} />
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default SatisfactionDetailModal;
